
import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useNavigate } from "react-router";
import { setGlobalLocationFilter } from "../../../apiclients/streamsapi_bridge";

const DeleteUserFilter = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    // const [isloading, setIsloading] = useState(false)

    async function removeThisFilter(e) {
        e.preventDefault();
        console.log(props.filterKey);
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        props.setIsloading(true);
        let update = {
            reqid: 62,
            siteid: siteid,
            filter_value: [-1],
            filter_type: 1,
            filter_key: parseInt(props.filterKey),
        }

        console.log("Modify User filter value  :::: " + JSON.stringify(update));
        let deleteFilter = await setGlobalLocationFilter(update);
        setTimeout(() => {
            props.setIsloading(false);
        }, 1000);
        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/userlanding";
        } else {
            localStorage.setItem("s_message", deleteMsg.message);
            sessionStorage.removeItem('userSeatFilter');
            sessionStorage.removeItem('userRoleFilter');
            if (props.locUser) {
                navigate("/locationsusers", {
                    state: { tab: props.locUser },
                });

            } else if (props.groupInfo) {
                navigate("/usersgroups", {
                    state: { tab: props.groupInfo },
                });

            }
            else if (props.groupUInfo) {
                navigate("/SelectedUserGroupSettings", {
                    state: { tab: "tab2", groupUInfo: props.groupUInfo },
                });
            } else {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "suser" },
                });
            }

            window.location.reload();
        }
    }

    return (
        <>
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}
            <div>
                <span className="phrecording">{t("RemoveFiltertxt")}</span>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisFilter(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { removeThisFilter(e) }}>
                    {t("add")}</button>
            </div>

        </>
    )
});

export default DeleteUserFilter;
